import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoupeChart from "../components/charts/CoupeChart";
import PlanningChart from "../components/charts/PlanningChart";
import EffectiveChart from "../components/charts/EffectiveChart";
import ChainChart from "../components/charts/ChainChart";
import AfterChainChart from "../components/charts/AfterChainChart";
import MargeNette from "../components/charts/MargeNette";
import Header from "../components/ui/Header";
import Sidebar from "../components/ui/Sidebar";
import PricePerMinute from "../components/charts/PricePerMinute";
import GammeProd from "../components/tables/GammeProd";
import GammeProdSummary from "../components/tables/GammeProdSummary";
import CoherenceGammePlanning from "../components/tables/CoherenceGammePlanning";
import DailyRecapTables from "../components/tables/DailyRecapTables";
import SuivrDeProd from "../components/tables/SuivrDeProd";
import SuivrDeEffect from "../components/tables/SuivrDeEffect";
import DetailedRealEffective from "../components/tables/DetailedRealEffective";
import MargeNetteTable from "../components/tables/MargeNetteTable";
import MargeNetteChainChart from "../components/charts/MargeNetteChainChart";
import Taux from "../components/charts/Taux";
import Retouche from "../components/charts/Retouche";

const Dashboard = () => {
  const [sidebar, setSidebar] = useState(false);
  const navigate = useNavigate();
  const isGerant = localStorage.getItem("role") === "Gerant";
  const isDeveloper = localStorage.getItem("role") === "developer";
  const canViewDailyRecaps = isDeveloper || isGerant;

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    // redirect to home if not logged in
    if (!token) {
      navigate("/");
    } else {
      // Check for the role
      const allowedRoles = ["admin", "superadmin", "developer", "Gerant"];
      if (!allowedRoles.includes(role)) {
        navigate("/");
      }
    }
  }, [navigate]);

  useEffect(() => {
    const closeSidebar = (event) => {
      if (event.key === "Escape") setSidebar(false);
    };

    document.addEventListener("keydown", closeSidebar);
    document.body.style.overflow = sidebar ? "hidden" : "";

    return () => {
      document.removeEventListener("keydown", closeSidebar);
      document.body.style.overflow = "";
    };
  }, [sidebar]);

  return (
    <div className="dashboard-responsive min-h-screen overflow-x-hidden bg-gradient-to-br from-slate-50 to-slate-100">
      <Header sidebar={sidebar} setSidebar={setSidebar} />
      <Sidebar sidebar={sidebar} setSidebar={setSidebar} />

      {/* Main Content Area */}
      <main className="min-w-0 ml-0 lg:ml-[16.67%] pt-20 md:pt-24 px-3 sm:px-5 lg:px-8">
        {/* Dashboard Header */}
        <div className="mb-5 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold leading-tight text-gray-900 mb-2">Tableau de Bord de Production</h1>
          <p className="text-sm sm:text-base text-gray-600">Surveillez les métriques de production, graphiques et analyses</p>
        </div>

        {/* Main Block Layout */}
        <div className="space-y-6 mb-8">
          {/* Production Overview */}
          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <CoherenceGammePlanning />
          </div>

          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <GammeProd />
            <GammeProdSummary />
          </div>)}

          {/* Charts */}
          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <PricePerMinute />
          </div>)}

          {canViewDailyRecaps && (
            <div className="dashboard-panel rounded-xl border border-gray-200 bg-slate-50 p-4 shadow-lg sm:p-6">
              <DailyRecapTables />
            </div>
          )}
          
          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <PlanningChart />
          </div>
          {/* Tables */}
          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <SuivrDeProd />
          </div>


          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <EffectiveChart />
          </div>

          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <SuivrDeEffect />
            <DetailedRealEffective />
          </div>


          
          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <CoupeChart />
          </div>

          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <ChainChart />
          </div>
          
          <div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <AfterChainChart />
          </div>

          
          {/* Additional Charts */}
          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <MargeNette />
          </div>)}

          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <MargeNetteChainChart />
          </div>)}

          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <MargeNetteTable />
          </div>)}

          
          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <Retouche />
          </div>)}

          {/* Full Width Tables */}

          {!isGerant && (<div className="dashboard-panel bg-white rounded-xl shadow-lg border border-gray-200 p-4 sm:p-6">
            <Taux />
          </div>)}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
